export const aiAgent = {
  head: {
    chip: "Recepcja AI",
    listingLabel: "Oferta:",
  },
  globalNote: {
    title: "Ustawienia dla całego konta",
    body: "Obejmuje <b>WSZYSTKIE Twoje obiekty</b>. Agent AI obsługuje każdego, kto pisze po raz pierwszy na Twój <b>podłączony numer WhatsApp</b> i <b>nie jest jeszcze klientem ani nie ma rezerwacji</b>: odpowiada na pytania i prowadzi go do rezerwacji.",
  },
  perListingNote: {
    title: "Konfigurowane osobno dla każdej oferty",
    body: "Wystawianie faktur korzysta z <b>wystawcy faktur</b> powiązanego z daną ofertą, dlatego włącza się je i dostosowuje w ustawieniach każdej oferty (a nie globalnie). Otwórz ofertę i przejdź do „Wystawianie faktur”.",
  },
  noEmisor: {
    title: "Ta oferta nie ma wystawcy faktur",
    body: "Wystawiania faktur nie można włączyć, dopóki do tej oferty nie zostanie przypisany wystawca w sekcji <b>Moje konto → Faktury elektroniczne</b>. Każdy wystawca jest przypisany do jednej oferty.",
  },
  master: {
    requiresEmisor: "Wymaga wystawcy faktur",
    on: "Włączone",
    off: "Wyłączone",
  },
  cartelQr: {
    title: "Plakat check-in dla recepcji",
    hint: "Wydrukuj go i zostaw na ladzie: gość skanuje kod, wpisuje numer rezerwacji i robi check-in z telefonu. Przydatne, gdy OTA nie przesyła wszystkich danych.",
    steps: "Gość skanuje kod · wpisuje numer rezerwacji · uzupełnia swoje dane.",
    download: "Pobierz plakat (PDF)",
    downloading: "Przygotowywanie…",
    downloadError: "Nie udało się przygotować plakatu.",
    copy: "Kopiuj link",
    copied: "Link skopiowany",
    language: "Język plakatu",
    alsoEnglish: "Dodaj angielski pod spodem",

    copyManual: "Nie udało się skopiować. Zaznacz link i skopiuj ręcznie.",
    popupBlocked: "Przeglądarka zablokowała okno. Skopiuj link i otwórz w nowej karcie.",
    loadError: "Nie udało się wczytać plakatu.",
    retry: "Spróbuj ponownie",  },
  checkinSchedule: {
    title: "Kiedy zaczyna się check-in?",
    hint: "Zaplanuj, kiedy agent wysyła gościowi link do check-in. Obowiązuje na poziomie oferty.",
  },
  avisoCheckin: {
    title: "Wyślij e-mail po zakończeniu zameldowania",
    hint: "Gdy grupa zakończy rejestrację, wysyłamy podsumowanie rezerwacji — główny gość, osoby towarzyszące i ich dokumenty — z podpisaną kartą w załączniku. Przydatne dla portierni lub recepcji.",
    enable: "Wyślij powiadomienie",
    steps: "Wysyłane raz, gdy zarejestruje się ostatnia osoba z grupy.",
    placeholder: "portiernia@twojobiekt.com",
    add: "Dodaj e-mail",
    remove: "Usuń",
    max: "Maksymalnie {n} adresów.",
    save: "Zapisz",
    saving: "Zapisywanie…",
    saved: "Powiadomienie zapisane",
    saveError: "Nie udało się zapisać.",
    badEmail: "„{email}” to nieprawidłowy adres.",
    needOne: "Dodaj co najmniej jeden e-mail, aby włączyć powiadomienie.",
  },
  field: {
    optional: "(opcjonalnie)",
    yes: "Tak",
    no: "Nie",
  },
  variant: {
    nationality: "Narodowość",
    writingStyle: "Styl wypowiedzi",
  },
  robot: {
    title: "Co wie agent",
  },
  pdf: {
    loaded: "Dokument wgrany · agent odczyta jego treść",
    remove: "Usuń",
    replace: "Zastąp PDF",
    dropTitle: "Wgraj plik PDF lub Word z przewodnikiem po obiekcie",
    dropHint: "PDF lub .docx · maks. 15 MB",
  },
  payments: {
    required: "Wymaga podłączenia platformy płatniczej",
    connect: "Podłącz platformę płatniczą →",
  },
  faq: {
    qPlaceholder: "Pytanie · np. Czy jest parking?",
    aPlaceholder: "Odpowiedź · np. Tak, bezpłatny przed budynkiem.",
  },
  list: {
    remove: "Usuń",
    add: "Dodaj",
  },
  footer: {
    saved: "Zapisano",
    save: "Zapisz zmiany",
  },
  wa: {
    online: "online",
    caption: "Podgląd · aktualizuje się wraz z ustawieniami",
    defaultName: "Recepcja AI",
  },
  errors: {
    pdfType: "Plik musi być w formacie PDF lub Word (.docx).",
    pdfSize: "Plik przekracza 15 MB.",
    pdfNoText: "Nie udało się odczytać żadnego tekstu z dokumentu (czy to skan albo pusty PDF?). Spróbuj z innym plikiem lub użyj dowolnego tekstu.",
    pdfUpload: "Nie udało się wgrać pliku PDF.",
    pdfRemove: "Nie udało się usunąć pliku PDF.",
    loadConfig: "Nie udało się wczytać ustawień.",
    saveConfig: "Nie udało się zapisać. Spróbuj ponownie.",
  },
  features: {
    general: {
      title: "Ustawienia ogólne",
      subtitle: "Określ tożsamość i styl agenta. To ustawienie KONTA: obejmuje WSZYSTKIE Twoje obiekty.",
      sections: {
        identity: {
          label: "Tożsamość agenta",
          hint: "Jak się przedstawia i w jakim stylu odpowiada.",
        },
      },
      fields: {
        agentName: {
          label: "Nazwa agenta",
          placeholder: "np. Sofía, Recepcja Loft Ámbar…",
        },
        persona: {
          label: "Osobowość",
          options: {
            amigable: "Przyjazna i ciepła",
            profesional: "Profesjonalna i zaradna",
            eficiente: "Bezpośrednia i skuteczna",
            entusiasta: "Entuzjastyczna i serdeczna",
            sereno: "Spokojna i wyluzowana",
          },
        },
        tone: {
          label: "Ton odpowiedzi",
          options: {
            cercano: "Swobodny",
            cordial: "Serdeczny",
            formal: "Formalny",
            profesional: "Profesjonalny",
          },
        },
        responseLength: {
          label: "Długość odpowiedzi",
          options: {
            brief: "Krótka (1-2 zdania)",
            balanced: "Zrównoważona",
            detailed: "Szczegółowa",
          },
        },
        useEmojis: {
          label: "Używaj emoji",
        },
        language: {
          label: "Język główny",
          options: {
            auto: "Automatyczny (zależnie od gościa)",
            es: "Hiszpański",
            en: "Angielski",
            fr: "Francuski",
            de: "Niemiecki",
            pt: "Portugalski",
            it: "Włoski",
          },
        },
        spanishVariant: {
          label: "Styl wypowiedzi (hiszpański)",
        },
        signature: {
          label: "Podpis na końcu",
          placeholder: "np. Zespół Loft Ámbar 🏡",
        },
      },
    },
    knowledge: {
      title: "Baza wiedzy",
      subtitle: "Wszystko, co Agent AI musi wiedzieć, aby rzetelnie obsługiwać Twoich gości.",
      enableLabel: "Agent korzysta z tej bazy wiedzy",
      sections: {
        knowledge: {
          label: "Wiedza o obiekcie",
          hint: "Wybierz, w jaki sposób przekazujesz informacje, z których skorzysta agent.",
        },
        behavior: {
          label: "Zachowanie i ograniczenia",
          hint: "Ustal zasady agenta oraz moment, w którym ma poprosić o pomoc człowieka.",
        },
      },
      fields: {
        kbMode: {
          label: "W jaki sposób chcesz przekazać informacje?",
          options: {
            form: "Formularze",
            text: "Dowolny tekst",
            pdf: "Wgraj dokument",
          },
        },
        propertyType: {
          label: "Rodzaj obiektu",
          options: {
            apartment: "Apartament",
            house: "Dom",
            villa: "Willa",
            loft: "Loft",
            room: "Pokój",
            cabin: "Domek",
            hotel: "Hotel",
            hostel: "Hostel",
          },
        },
        kbText: {
          label: "Informacje o obiekcie",
          placeholder: "Napisz lub wklej tutaj WSZYSTKO, co agent powinien wiedzieć: sieć WiFi i hasło, parking, sprzęty, ogrzewanie i klimatyzacja, regulamin, lokalne polecenia…",
          hint: "Agent wykorzysta ten tekst w odpowiedziach dokładnie w takiej formie.",
        },
        kbPdf: {
          label: "Dokument obiektu",
          hint: "Wgraj przewodnik po obiekcie w formacie PDF lub Word (.docx). Agent odczyta jego treść, aby odpowiadać.",
        },
        description: {
          label: "Informacje ogólne",
          placeholder: "Jak działa ogrzewanie i klimatyzacja, sprzęty, sterowanie temperaturą, osobliwości obiektu…",
          hint: "Główny kontekst, z którego agent skorzysta w każdej odpowiedzi.",
        },
        wifiName: {
          label: "Nazwa sieci WiFi",
          placeholder: "MojeWifi_5G",
        },
        wifiPassword: {
          label: "Hasło do WiFi",
        },
        parkingInfo: {
          label: "Parking",
          placeholder: "Bezpłatny parking przed budynkiem / Płatny parking 100 m dalej / Brak parkingu…",
        },
        amenities: {
          label: "Udogodnienia i wyposażenie",
          placeholder: "Wyposażona kuchnia, pralka, suszarka, klimatyzacja, winda, łóżeczko dziecięce, ręczniki…",
        },
        houseRules: {
          label: "Regulamin obiektu",
          placeholder: "Zakaz palenia, zakaz imprez, brak zgody na zwierzęta, cisza nocna 22:00–08:00…",
        },
        localRecommendations: {
          label: "Lokalne polecenia",
          placeholder: "Restauracje, sklepy, komunikacja, co warto zobaczyć w okolicy…",
        },
        faqs: {
          label: "Najczęściej zadawane pytania",
          hint: "Pary pytanie i odpowiedź. Do każdej z nich możesz dołączyć zdjęcia lub filmy.",
        },
        links: {
          label: "Linki i dokumenty",
          itemPlaceholder: "https://… (przewodnik po obiekcie, instrukcja, mapa)",
          hint: "Zewnętrzne materiały, z których agent może korzystać.",
        },
        sendAmenityPhotos: {
          label: "Wysyłaj zdjęcia wyposażenia i udogodnień",
          hint: "Jeśli gość zapyta o udogodnienie, które ma zdjęcia, agent odpowie i je wyśle. Jeśli ich nie ma, odpowie tylko tekstem.",
        },
        customInstructions: {
          label: "Własne instrukcje",
          placeholder: "Konkretne zasady dotyczące tonu lub treści. Np. zawsze proponuj późny check-out, gdy gość pyta o wyjazd.",
        },
        forbiddenTopics: {
          label: "Zakazane tematy i działania",
          placeholder: "Np. nie udzielaj rabatów, nie potwierdzaj zmiany terminu bez zgody, nie podawaj danych innych gości.",
        },
        escalationRules: {
          label: "Kiedy przekazać rozmowę człowiekowi",
          placeholder: "Np. w razie awarii, poważnej skargi lub prośby o zwrot pieniędzy przekaż rozmowę gospodarzowi.",
        },
        fallbackMessage: {
          label: "Wiadomość, gdy agent nie zna odpowiedzi",
          placeholder: "Nie mam teraz tej informacji, ale przekażę to gospodarzowi i wrócimy do Ciebie od razu 🙌",
        },
        humanContact: {
          label: "Kontakt do gospodarza",
          placeholder: "+34 600 000 000",
        },
        supportHours: {
          label: "Godziny wsparcia człowieka",
          placeholder: "Pon–Niedz. 09:00–21:00",
        },
      },
    },
    checkin: {
      title: "Check-in",
      enableLabel: "Obsługuj check-in automatycznie",
    },
    newBookings: {
      title: "Nowe rezerwacje i zapytania",
      subtitle: "Agent obsługuje nowych zainteresowanych (osoby piszące po raz pierwszy, które chcą zarezerwować lub mają pytania) i wysyła im link do rezerwacji bezpośredniej, aby dokończyli rezerwację na stronie. To ustawienie KONTA: obejmuje wszystkie Twoje obiekty.",
      enableLabel: "Obsługuj zapytania i prośby o rezerwację",
      sections: {
        businessIdentity: {
          label: "Tożsamość firmy",
          hint: "Nazwa, którą agent podaje osobom, które jeszcze nie zarezerwowały.",
        },
        newLeads: {
          label: "Nowi zainteresowani · pierwszy kontakt",
          hint: "Jak agent obsługuje osobę, która pisze po raz pierwszy, jest zainteresowana i jeszcze nie zarezerwowała.",
        },
        bookingLink: {
          label: "Link do rezerwacji",
        },
      },
      fields: {
        businessName: {
          label: "Nazwa firmy",
          placeholder: "np. Hostel Elios, Apartamentos del Puerto, Grupo Ámbar…",
          hint: "Gdy osoba bez rezerwacji zapyta, kim jesteś, agent odpowie „Jestem asystentem [ta nazwa]”. Jeśli zostawisz to pole puste, przedstawi się ogólnie, nie podając nazwy firmy.",
        },
        leadWelcomeMessage: {
          label: "Wiadomość powitalna dla nowego zainteresowanego",
          placeholder: "Cześć! 👋 Jestem asystentem obiektu. Szukasz terminu na wyjazd czy masz jakieś pytania? Chętnie pomogę 😊",
          hint: "Powitanie przy pierwszym kontakcie, gdy ktoś pisze po raz pierwszy. Nie powtarza się w kolejnych wiadomościach.",
        },
        leadWelcomeVerbatim: {
          label: "Wyślij powitanie dosłownie (bez dostosowania)",
          hint: "Włączone: agent używa Twojej wiadomości słowo w słowo przy pierwszym kontakcie. Wyłączone: dostosowuje ją do tonu rozmowy.",
        },
        answerKbForLeads: {
          label: "Odpowiadaj na pytania jeszcze przed rezerwacją",
          hint: "Agent odpowiada na ogólne pytania na podstawie bazy wiedzy (nawet jeśli rozmówca nie jest jeszcze gościem) i może też wysłać mu link do rezerwacji.",
        },
        proactiveOffer: {
          label: "Proponuj rezerwację z własnej inicjatywy",
          hint: "Nawet jeśli zainteresowany pyta o inne rzeczy, agent zachęca go do rezerwacji i wysyła link w odpowiednim momencie, bez nachalności.",
        },
        offerMessage: {
          label: "Wiadomość przy proponowaniu rezerwacji",
          placeholder: "Jasne! Możesz zarezerwować bezpośrednio tutaj 👇 Wysyłam link do wyboru terminu.",
          hint: "Ton, jakiego agent używa, proponując rezerwację. Link dodaje automatycznie.",
        },
      },
    },
    earlyAccess: {
      title: "Obsługa godziny przyjazdu",
      subtitle: "Agent obsługuje prośby o wcześniejszy check-in: zapisuje godzinę przyjazdu wskazaną przez gościa i postępuje zgodnie z Twoimi zasadami.",
      enableLabel: "Obsługuj godziny przyjazdu",
      sections: {
        request: {
          label: "Obsługa prośby",
          hint: "Jak agent odpowiada w zależności od wskazanej godziny. Po wyłączeniu tych opcji prośba pozostaje oczekująca, a decyzję podejmujesz samodzielnie (Zatwierdź / Zatwierdź inną godzinę / Nadaj priorytet / Odrzuć).",
        },
      },
      fields: {
        autoTentativeEarly: {
          label: "Odpowiadaj „w miarę dostępności”, jeśli przyjazd jest przed check-in",
          hint: "Agent informuje gościa, że postaracie się to umożliwić; prośba czeka na Twoje potwierdzenie.",
        },
        autoApproveLate: {
          label: "Zatwierdzaj automatycznie, jeśli przyjazd jest po check-in",
          hint: "Przyjazd w zwykłych godzinach jest potwierdzany samoczynnie.",
        },
      },
    },
    lateCheckout: {
      title: "Późny check-out",
      subtitle: "Agent obsługuje prośby o późny check-out: sprawdza godzinę, podaje cenę i zapisuje prośbę.",
      enableLabel: "Obsługuj późny check-out",
      sections: {
        availability: {
          label: "Dostępność i godziny",
        },
        extraPrice: {
          label: "Cena dodatkowej godziny",
          hint: "Naliczana jest tylko część wykraczająca poza godziny bezpłatne.",
        },
        messages: {
          label: "Wiadomości",
        },
      },
      fields: {
        standardCheckout: {
          label: "Standardowa godzina check-out",
        },
        courtesyHours: {
          label: "Godziny bezpłatne",
          unit: "godz.",
          hint: "Godziny po standardowym check-out, które NIGDY nie są płatne.",
        },
        latestTime: {
          label: "Najpóźniejsza godzina check-out",
          hint: "Granica bezwzględna. Po godzinach bezpłatnych dodatkowe godziny są płatne.",
        },
        subjectToAvailability: {
          label: "W miarę dostępności",
          hint: "Dodatkowe godziny są oferowane tylko wtedy, gdy tego dnia nie przyjeżdża kolejna rezerwacja.",
        },
        autoConfirm: {
          label: "Potwierdzaj automatycznie, gdy gość się zgodzi",
          hint: "Dotyczy wyłącznie godzin bezpłatnych.",
        },
        pricingModel: {
          label: "Model cenowy",
          options: {
            fixed: "Cena stała",
            perHour: "Za każdą dodatkową godzinę",
          },
        },
        price: {
          label: "Kwota",
          hint: "Cena stała albo stawka za każdą dodatkową godzinę po okresie bezpłatnym.",
        },
        freeIfAvailable: {
          label: "Bezpłatnie, jeśli tego dnia nie ma przyjazdu",
          hint: "Jeśli dany dzień jest wolny, dodatkowe godziny również nie są płatne.",
        },
        paymentMethods: {
          label: "Metody płatności za dodatkowe godziny",
          options: {
            online: "Płatność online (Stripe), agent wysyła link",
            cash: "Gotówka przy wyjeździe",
          },
          hint: "Możesz udostępnić jedną z nich albo obie. Agent poinformuje o tym gościa.",
        },
        offerMessage: {
          label: "Wiadomość z ofertą",
          placeholder: "Potrzebujesz więcej czasu? Możemy zaproponować check-out do 13:00.",
        },
        confirmationMessage: {
          label: "Wiadomość potwierdzająca",
          placeholder: "Gotowe! Późny check-out jest potwierdzony. Miłego korzystania z dodatkowych godzin 🙌",
        },
      },
    },
    invoicing: {
      title: "Wystawianie faktur",
      subtitle: "Agent wysyła gościowi link do uzupełnienia danych do faktury i pobrania faktury elektronicznej, korzystając z wystawcy faktur powiązanego z tą ofertą.",
      enableLabel: "Obsługuj prośby o faktury",
      sections: {
        whenSend: {
          label: "Kiedy wysyłany jest link do faktury?",
          hint: "Wybierz, w jaki sposób link trafia do gościa. Opcje wybranego trybu pojawią się poniżej.",
        },
        requirements: {
          label: "Warunki natychmiastowej wysyłki",
          hint: "Agent przekazuje link tylko gościom, którzy zakończyli check-in i opłacili rezerwację w całości; po uzupełnieniu danych faktura jest wystawiana i pobierana natychmiast. W przypadku rezerwacji z OTA (Booking/Airbnb) fakturę można otrzymać dopiero po rozpoczęciu usługi (gdy pobyt się zaczął) i po pełnej zapłacie.",
        },
        manualReview: {
          label: "Weryfikacja ręczna",
          hint: "Zapisywana jest wyłącznie prośba gościa, która czeka w sekcji „Faktury do wysłania”, abyś wystawił ją ręcznie. Żadna faktura nie powstaje automatycznie i nie ma znaczenia, kiedy gość poprosi ani czy rezerwacja jest opłacona (decyzja należy do Ciebie).",
        },
        fiscalData: {
          label: "Dane podatkowe wystawcy",
          hint: "Danych podatkowych (nazwa firmy, NIP, seria, VAT, Verifactu) NIE ustawia się tutaj: pobierane są od wystawcy faktur powiązanego z tą ofertą w sekcji Moje konto → Faktury elektroniczne.",
        },
        sendToGuest: {
          label: "Wysyłka do gościa",
        },
      },
      modes: {
        after_checkout: {
          label: "Tylko na prośbę",
          desc: "Konsjerż AI odpowiada, gdy gość poprosi o fakturę.",
        },
        always_after_checkout: {
          label: "Zawsze, gdy kończy się pobyt",
          desc: "Do każdego, kto zakończył check-in, niezależnie od tego, czy poprosi, czy nie. Zalecane.",
        },
      },
      cards: {
        on_request: {
          label: "Zaraz po prośbie",
          desc: "Gość otrzymuje link od razu, jeśli spełnia warunki.",
        },
        after_checkout: {
          label: "Gdy kończy się pobyt",
          desc: "Prośba zostaje zapisana, a link trafia do gościa po check-out.",
        },
        manual: {
          label: "Tylko zapisz prośbę",
          desc: "Pozostaje oczekująca, a fakturę wystawiasz ręcznie.",
        },
      },
      fields: {
        autoIssueIfNotSubmitted: {
          label: "Wystaw fakturę, nawet jeśli gość nie wypełni formularza",
          hint: "Faktura powstaje na podstawie danych z check-in, a PDF trafia do gościa e-mailem i przez WhatsApp. Wystawionej faktury nie można edytować.",
        },
        autoIssueAfterHours: {
          label: "Jak długo czekać przed wystawieniem",
          options: {
            h24: "24 godziny po wysłaniu linku",
            h48: "48 godzin po wysłaniu linku",
            h72: "72 godziny po wysłaniu linku",
          },
        },
        manualSendLink: {
          label: "Wyślij gościowi link do uzupełnienia danych do faktury",
          hint: "Po włączeniu agent wysyła link, aby gość mógł podać swoje dane z wyprzedzeniem. Faktura nadal jest wystawiana ręcznie.",
        },
        sendToGuest: {
          label: "Wyślij gościowi link przez",
          options: {
            email: "E-mail",
            whatsapp: "WhatsApp",
          },
        },
      },
    },
    extendStay: {
      title: "Przedłużenie pobytu",
      subtitle: "Agent obsługuje prośby o dodanie nocy: sprawdza dostępność, podaje cenę i zapisuje prośbę.",
      enableLabel: "Zezwalaj na prośby o przedłużenie pobytu",
      sections: {
        availability: {
          label: "Dostępność",
          hint: "Maksymalna liczba nocy wynika automatycznie z kolejnej rezerwacji w kalendarzu.",
        },
        price: {
          label: "Cena",
        },
        messages: {
          label: "Wiadomości",
        },
      },
      fields: {
        autoConfirm: {
          label: "Przedłuż rezerwację automatycznie po potwierdzeniu",
          hint: "Po wyłączeniu pozostaje to prośbą, którą sam zatwierdzasz.",
        },
        useListingRate: {
          label: "Użyj stawki za noc z tej oferty",
          hint: "Oblicza stawkę na podstawie ceny rezerwacji.",
        },
        pricePerNight: {
          label: "Cena za dodatkową noc",
          hint: "Tylko jeśli nie korzystasz ze stawki z oferty.",
        },
        paymentMethods: {
          label: "Metody płatności za dodatkowe noce",
          options: {
            online: "Płatność online (Stripe), agent wysyła link",
            cash: "Gotówka",
          },
        },
        offerMessage: {
          label: "Wiadomość z ofertą",
          placeholder: "Chcesz zostać dłużej? Mogę dodać noce do Twojej rezerwacji, w miarę dostępności.",
        },
        confirmationMessage: {
          label: "Wiadomość potwierdzająca",
          placeholder: "Świetnie! Zapisałem dodatkowe noce. Potwierdzimy je, gdy tylko płatność zostanie zakończona 🙌",
        },
      },
    },
  },
  preview: {
    common: {
      noCost: "bez dodatkowych kosztów",
      subjectToAvailability: " W miarę dostępności.",
    },
    default: "Cześć! W czym mogę pomóc? 😊",
    knowledge: {
      guestWifi: "Jakie jest hasło do WiFi? 📶",
      wifiAnswer: "Jasne! Sieć WiFi to *{name}*, a hasło to *{pass}*. Miłego korzystania! 😊",
      wifiNameFallback: "sieć obiektu",
      wifiPassFallback: "••••••",
      genericAnswer: "Oczywiście! Już wysyłam Ci wszystkie potrzebne informacje o obiekcie 😊",
    },
    checkin: {
      propFallback: "tu alojamiento",
      welcome: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{prop}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{prop}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
      ok: "Ok",
      chooseLang: "Elige tu idioma · Choose your language",
      langEs: "Español",
      langEn: "English",
      linkMsg: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎\n\n{link}",
    },
    newBookings: {
      offerDefault: "Oczywiście! 😊 Możesz zarezerwować bezpośrednio tutaj. Wysyłam link do wyboru terminu:",
      whoAsk: "Z kim rozmawiam?",
      whoAnswer: "Cześć! Jestem asystentem {biz} 😊 W czym mogę pomóc?",
      guestGreeting: "Cześć! Macie coś wolnego w ten weekend? 😊",
      howBook: "Super, jak mogę zarezerwować?",
      linkLine: "{offer}\n\n🔗 Zarezerwuj tutaj: {link}",
    },
    earlyAccess: {
      guestAsk: "Czy mogę zrobić check-in wcześniej? Będę około południa 🙏",
      tentativeReply: "Zapisaliśmy Twój wcześniejszy przyjazd na 12:00. Zrobimy wszystko, aby obiekt był gotowy, ale zależy to od check-out poprzednich gości i od sprzątania. Damy znać, gdy tylko będzie dostępny 🙏",
      confirmedReply: "Zapisaliśmy Twój wcześniejszy przyjazd na 12:00. Wkrótce potwierdzimy 🙏",
    },
    lateCheckout: {
      courtesyPart: "Po {time} masz jeszcze {hours} godz. bezpłatnej karencji. ",
      costPart: "Check-out do {time} kosztuje {price}{perHour}.",
      perHourSuffix: " za każdą dodatkową godzinę",
      payBoth: " Możesz zapłacić online albo gotówką przy wyjeździe.",
      payCash: " Płatność gotówką przy wyjeździe.",
      guestAsk: "Mogę jutro wyjechać później? 😅",
      guestConfirm: "OK, potwierdzam 👍",
      cashExtra: " (albo gotówką przy wyjeździe)",
      confirmPayDefault: "Gotowe! Aby potwierdzić, dokończ płatność{extra}:",
      payLabel: "Zapłać {price}",
      confirmCashDefault: "Gotowe! Późny check-out jest potwierdzony. Kwotę {price} płacisz gotówką przy wyjeździe. 😊",
    },
    invoicing: {
      guestAsk: "Możesz przesłać mi fakturę? 🧾",
      linkMsg: "Cześć! 👋\n\nOto Twój link do wygenerowania i pobrania faktury elektronicznej:\n{link}\n\nMożesz wracać do tego linku, kiedy tylko będziesz potrzebować faktury.",
      thanks: "Dziękujemy za pobyt! 🙌 Jeśli potrzebujesz faktury, oto link 👇",
      autoIssueNote: "_({hours} godz. później, jeśli gość nie uzupełnił danych)_\n\nWystawiliśmy Twoją fakturę na podstawie danych z check-in i wysłaliśmy ją e-mailem. 📩",
      manualLinkMsg: "Cześć! 👋\n\nOto link do uzupełnienia danych do faktury:\n{link}\n\nSprawdzimy Twoje zgłoszenie i wystawimy fakturę ręcznie. 😊",
      manualRegistered: "Cześć! 👋 Zapisałem Twoją prośbę o fakturę. Sprawdzimy ją i wystawimy fakturę ręcznie najszybciej, jak to możliwe. Dzięki! 😊",
    },
    extendStay: {
      guestAsk: "Mogę zostać jeszcze jedną noc? 🌙",
      guestConfirm: "Tak, jeszcze jedną noc 👍",
      rateListing: "w cenie z Twojej rezerwacji",
      ratePerNight: "w cenie {price} za noc",
      nightSingular: "nocy",
      nightPlural: "nocy",
      offerDefault: "Jasne! Mogę dodać maksymalnie do {max} {nights} {rate}.{avail}",
      cashExtra: " (albo gotówką)",
      confirmPayDefault: "Świetnie! Aby potwierdzić dodatkową noc, dokończ płatność{extra}:",
      payLabel: "Zapłać za dodatkową noc",
      confirmCashDefault: "Świetnie! Zapisałem dodatkową noc. Płatność jest gotówką, a gospodarz potwierdzi przedłużenie. 😊",
    },
    general: {
      guestAsk: "Cześć! Z kim rozmawiam?",
      whoWithName: "Jestem {name}, Twoim",
      whoNoName: "Jestem Twoim",
      answer: "Cześć! {who} asystentem recepcji. W czym mogę pomóc?{emo}",
    },
  },
  nationalities: {
    auto: "Automatycznie (zależnie od gościa)",
    latam: "Ameryka Łacińska (neutralny)",
    countries: {
      ES: "Hiszpania",
      MX: "Meksyk",
      CO: "Kolumbia",
      AR: "Argentyna",
      CL: "Chile",
      PE: "Peru",
      VE: "Wenezuela",
      EC: "Ekwador",
      UY: "Urugwaj",
      PY: "Paragwaj",
      BO: "Boliwia",
      CR: "Kostaryka",
      PA: "Panama",
      GT: "Gwatemala",
      DO: "Dominikana",
      PR: "Portoryko",
      CU: "Kuba",
      FR: "Francja",
      PT: "Portugalia",
      BR: "Brazylia",
      US: "Stany Zjednoczone",
      IT: "Włochy",
      BE: "Belgia",
      MA: "Maroko",
      NL: "Holandia",
      CH: "Szwajcaria",
    },
    styles: {
      latamNeutral: "Neutralny latynoamerykański",
      esES: "Standardowy, nieformalny (tú) · «vale», «genial»",
      esMX: "Standardowy · «con gusto», «estacionamiento»",
      esCO: "Ogólny, formalny (usted) · «con gusto»",
      esCOpaisa: "Paisa (Medellín) · «pues», «hágale»",
      esCOcosta: "Wybrzeże (Karaiby) · «¡ajá!», «quihubo»",
      esCOrolo: "Rolo (Bogotá), formalny (usted) · «a la orden»",
      esCOvalle: "Valluno (Cali), voseo · «vea pues»",
      esCOsantander: "Santander, bezpośredni · «de una»",
      esAR: "Voseo · «dale», «buenísimo»",
      esCL: "Ciepły · «estacionamiento»",
      esPE: "Formalny (usted) · neutralny andyjski",
      esVE: "Nieformalny (tú) · «chévere»",
      esEC: "Formalny (usted) · neutralny andyjski",
      esUY: "Voseo · «ta», «bo»",
      esPY: "Voseo · ciepły",
      esBO: "Formalny (usted) · andyjski",
      esCR: "Voseo · «pura vida»",
      esPA: "Nieformalny (tú) · karaibski",
      esGT: "Formalny (usted) · ciepły",
      esDO: "Nieformalny (tú) · karaibski",
      esPR: "Nieformalny (tú) · karaibski",
      esCU: "Nieformalny (tú) · karaibski",
      frFR: "Francuski (Francja)",
      ptPT: "Portugalski (Portugalia)",
      ptBR: "Portugalski (Brazylia)",
      enUS: "Angielski amerykański",
      itIT: "Włoski (Włochy)",
      frBE: "Francuski (Belgia)",
      nlBE: "Niderlandzki / flamandzki (Belgia)",
      arMA: "Arabski (Maroko)",
      frMA: "Francuski (Maroko)",
      nlNL: "Niderlandzki",
      deCH: "Szwajcarski niemiecki",
      frCH: "Szwajcarski francuski",
      itCH: "Szwajcarski włoski",
    },
  },
};
